import React, { useRef } from "react";
import About from "../../components/About";
// import AboutCompany from "../../components/AboutCompany";
import { Banner } from "../../components/Banner";
import Cart from "../../components/Cart";
import CartCadeau from "../../components/CartCadeau";
import Category from "../../components/Category";
import Contact from "../../components/Contact";
import Form from "../../components/Form";
import LoaderScreen from "../../components/LoaderScreen";
// import Info from "../../components/Info";
import Offers from "../../components/Offers";
import Reviews from "../../components/Reviews";
// import WSPGallery from "../../components/WSPGalery";
import ScrollToTopArrow from "../../components/ScrollToTopArrow";
// import PromoModal from "../../components/PromoModal";

// const galleryImages = [
//   {
//     img: "https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/3861458/pexels-photo-3861458.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/1194713/pexels-photo-1194713.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/3861458/pexels-photo-3861458.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/1194713/pexels-photo-1194713.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {
//     img: "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
// ];

const Home = () => {
  const categoryRef = useRef<HTMLDivElement>(null);
  return (
    <>
      <LoaderScreen />
      {/* <PromoModal /> */}
      <Banner />
      <Category ref={categoryRef} />
      <About />
      <Cart />
      <CartCadeau />
      <Offers />
      {/* <Info /> */}
      {/* <AboutCompany /> */}
      <Form />
      <Reviews />
      {/* <WSPGallery galleryImages={galleryImages} /> */}
      <Contact />
      <ScrollToTopArrow targetRef={categoryRef} />
    </>
  );
};

export default Home;
